const serializers = {};
export function add(serializer, ...contentType) {
    contentType.forEach(t => (serializers[t] = serializer));
}
export function serialize(body, contentType) {
    const serializer = serializers[contentType?.split(";")[0] ?? ""];
    return serializer ? serializer(body, contentType) : body;
}
//# sourceMappingURL=Serializer.js.map